import { Form, FormItem } from 'components/Base/Form';
import { useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import useForm from 'hooks/useForm';
import { useTranslation } from '@packages/utils';
import ProgressStepper from '../../components/ProgressStepper';
import { TRegistrationFormDataUI } from '../../../../../../data/types/events.types';
import useRegistrationContext from '../../context/NewRegistrationModalContext';
import {
  chooseLanguageSecionKey,
  registrationModalKey,
} from '../../../RegistrationModal/RegistrationModal.data';
import i18n from '../../../../../../i18n';
import ChildCareSection from './ChildCareSection/ChildCareSection';
import PhotoReleaseSection from './PhotoReleaseSection/PhotoReleaseSection';
import AcceptTerms from './AcceptTerms/AcceptTerms';
import { MobileDivider, StyledStepWrapper } from '../StepWrapper.style';
import BackNextButtons from '../../components/BackNextButtons';
import QuestionSection from './Question/QuestionSection';
import EmailNotification from './EmailNotification/EmailNotification';
import { NextStepButton } from '../../components/RegistrationContent/RegistationContent.style';

const reCaptchaSiteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY || '';

const ProvidingChildCare = ({ data }: { data?: TRegistrationFormDataUI }) => {
  const isProvidingChildCare = !!data?.childcareProvided;
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const { t } = useTranslation({
    keyPrefix: chooseLanguageSecionKey,
    lng: 'translate',
  });
  const { form } = useForm();

  const {
    registrationValues,
    setRegistrationValues,
    isRegistrationLoading,
    stepper,
    handleSubmit,
    eventDetails,
  } = useRegistrationContext();

  const { acceptedTerms, recaptchaResponse } = registrationValues;

  useEffect(() => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  }, [i18n.language]);

  const handleFormValuesChange = (changedValues: any, allValues: any) => {
    setRegistrationValues({
      ...registrationValues,
      ...allValues,
    });
  };

  useEffect(() => {
    setRegistrationValues({
      ...registrationValues,
      recaptchaResponse: '',
    });
  }, []);

  return (
    <>
      <ProgressStepper />
      <MobileDivider />
      <StyledStepWrapper>
        <Form
          form={form}
          onValuesChange={handleFormValuesChange}
          initialValues={{ recieveEmail: registrationValues.recieveEmail }}
        >
          {eventDetails?.customQuestion && <QuestionSection />}
          {isProvidingChildCare && <ChildCareSection />}
          <PhotoReleaseSection />
          <AcceptTerms registrationModalKey={registrationModalKey} />
          <EmailNotification registrationModalKey={registrationModalKey} />
          <FormItem name="recaptchaResponse">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={reCaptchaSiteKey}
              hl={i18n.language}
            />
          </FormItem>
        </Form>
      </StyledStepWrapper>
      <BackNextButtons customNextButton>
        <NextStepButton
          color="primary"
          type="primary"
          style={{ marginLeft: 'auto' }}
          disabled={
            (stepper === 3 ? !acceptedTerms || !recaptchaResponse : false) ||
            isRegistrationLoading
          }
          onClick={async () => {
            try {
              const values = await form.validateFields();
              if (values) {
                handleSubmit();
              }
            } catch {
              // do nothing; form will validate
            }
          }}
        >
          {t('REGISTER_BTN')}
        </NextStepButton>
      </BackNextButtons>
    </>
  );
};
export default ProvidingChildCare;
